import { getOptionValue } from "./options";

export const prepareOptions = (options) => {
  const changed = {};

  options.forEach((option) => {
    changed[option.code] = getOptionValue(option);
  });

  return changed;
};

export const mapStatuses = (statuses, quantities) => {
  const { online, offlineSiteClosed, offlineSiteOpen, pending, suspended } = statuses;
  const { onlineQty, offlineSiteClosedQty, offlineSiteOpenQty, pendingQty, SuspendedQty } =
    quantities;

  return [
    {
      key: "online",
      color: "green",
      text: "Online - Op.",
      disabled: !online,
      quantity: onlineQty,
    },
    {
      key: "pending",
      color: "orange",
      text: "Online - Non Op.",
      disabled: !pending,
      quantity: pendingQty,
    },
    {
      key: "offlineSiteOpen",
      color: "red",
      text: "Offline - Site Open",
      disabled: !offlineSiteOpen,
      quantity: offlineSiteOpenQty,
    },
    {
      key: "offlineSiteClosed",
      color: "blue",
      text: "Offline - Site Closed",
      disabled: !offlineSiteClosed,
      quantity: offlineSiteClosedQty,
    },
    {
      key: "suspended",
      color: "yellow",
      text: "Suspended Ops",
      disabled: !suspended,
      quantity: SuspendedQty 
    }
  ];
};

export const viewOptions = [
  { key: "Machine Status", value: 0, text: "Machine Status" },
  { key: "Current Comms Status", value: 1, text: "Current Comms Status" },
  {
    key: "Machine Operational Filters",
    value: 2,
    text: "Machine Operational Filters",
  },
];
